/**
 * Pricing: Website / Webshop — toont alleen kaarten met data-pricing-audience
 */
(function () {
  'use strict';

  function applyAudience(section, aud) {
    if (aud !== 'webshop' && aud !== 'website') aud = 'website';
    section.setAttribute('data-active-audience', aud);
    section.querySelectorAll('[data-pricing-audience]').forEach(function (el) {
      var m = el.getAttribute('data-pricing-audience');
      if (m === aud) {
        el.removeAttribute('hidden');
      } else {
        el.setAttribute('hidden', 'hidden');
      }
    });
    section.querySelectorAll('[data-audience-tab]').forEach(function (btn) {
      var on = (btn.getAttribute('data-audience-tab') || '') === aud;
      if (on) {
        btn.classList.add('pricing-audience-tab--active', 'shadow-sm');
        btn.classList.remove('text-muted-foreground', 'hover:text-foreground');
      } else {
        btn.classList.remove('pricing-audience-tab--active', 'shadow-sm');
        btn.classList.add('text-muted-foreground', 'hover:text-foreground');
      }
      btn.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  }

  function initSection(section) {
    var aud = section.getAttribute('data-active-audience') || 'website';
    applyAudience(section, aud);
    section.querySelectorAll('[data-audience-tab]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        applyAudience(section, btn.getAttribute('data-audience-tab') || 'website');
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-pricing-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  setTimeout(boot, 0);

  document.addEventListener('shopify:section:load', function (ev) {
    var section = ev.target && ev.target.querySelector && ev.target.querySelector('[data-pricing-section]');
    if (section) initSection(section);
  });
})();
